import {
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  TextField,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
} from "@mui/material";
import { useState } from "react";
import {
  Dashboard as DashboardIcon,
  School as SchoolIcon,
  Forum as ForumIcon,
  People as PeopleIcon,
  Analytics as AnalyticsIcon,
  Settings as SettingsIcon,
  AutoAwesome as AIIcon,
} from "@mui/icons-material";

export default function Analytics() {
  const [reportType, setReportType] = useState("users");
  const [dateRange, setDateRange] = useState("30days");
  const handleReportTypeChange = (event: SelectChangeEvent) => {
    setReportType(event.target.value);
  };

  const handleDateRangeChange = (event: SelectChangeEvent) => {
    setDateRange(event.target.value);
  };
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600, mb: 4 }}>
        Analytics & Reporting
      </Typography>

      <Card sx={{ mb: 4, p: 4 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Key Performance Indicators
          </Typography>
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <Select defaultValue="30days">
              <MenuItem value="30days">Last 30 Days</MenuItem>
              <MenuItem value="7days">Last 7 Days</MenuItem>
              <MenuItem value="quarter">This Quarter</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>
                User Growth
              </Typography>
              <Box
                sx={{
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#8395a7",
                  fontStyle: "italic",
                }}
              >
                Chart for New Users, DAU/MAU
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>
                Workshop Engagement
              </Typography>
              <Box
                sx={{
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#8395a7",
                  fontStyle: "italic",
                }}
              >
                Chart for Registrations, Creation Rate
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ p: 3, textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>
                Community Health
              </Typography>
              <Box
                sx={{
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#8395a7",
                  fontStyle: "italic",
                }}
              >
                Chart for New Posts, Active Topics
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Card>

      <Card sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
          Report Generation
        </Typography>
        <Grid container spacing={3} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Report Type</InputLabel>
              <Select
                value={reportType}
                onChange={handleReportTypeChange}
                label="Report Type"
              >
                <MenuItem value="users">All Users</MenuItem>
                <MenuItem value="workshops">All Workshops</MenuItem>
                <MenuItem value="marketplace">
                  All Marketplace Resources
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel>Date Range</InputLabel>
              <Select
                value={dateRange}
                onChange={handleDateRangeChange}
                label="Date Range"
              >
                <MenuItem value="30days">Last 30 Days</MenuItem>
                <MenuItem value="7days">Last 7 Days</MenuItem>
                <MenuItem value="quarter">This Quarter</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Button variant="contained" sx={{ bgcolor: "#4a69bd" }}>
          Generate & Download CSV
        </Button>
      </Card>
    </Box>
  );
}
